"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserialize = exports.serialize = void 0;

var _slate = require("slate");

var _prismjs = _interopRequireDefault(require("prismjs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require('prismjs/components/prism-markdown');

var serialize = function serialize(node) {
  if (Array.isArray(node)) {
    return node.map(serialize).join('');
  }

  if (_slate.Text.isText(node)) {
    var _text$match, _text$match2;

    var text = node.text;
    var spacesAtEnd = ' '.repeat(((_text$match = text.match(/(\s+$)/g)) === null || _text$match === void 0 ? void 0 : _text$match[0].length) || 0);
    var spacesAtStart = ' '.repeat(((_text$match2 = text.match(/(^_\s+)/g)) === null || _text$match2 === void 0 ? void 0 : _text$match2[0].length) || 0);

    if (node.italic) {
      text = "".concat(spacesAtStart, "_").concat(text.trim(), "_ ").concat(spacesAtEnd);
    }

    if (node.bold) {
      text = "".concat(spacesAtStart, "**").concat(text.trim(), "**").concat(spacesAtEnd);
    }

    return text;
  }

  var children = (node.children || []).map(serialize);

  switch (node.type) {
    case 'bulleted-list':
      return children.map(function (child) {
        return "* ".concat(child);
      }).join('\n');

    case 'numbered-list':
      return children.map(function (child, index) {
        return "".concat(index + 1, ". ").concat(child);
      }).join('\n');

    case 'quote':
      return "> ".concat(children.join(''), "\n");

    case 'paragraph':
      return "\n".concat(children.join(''), "\n");

    case 'link':
      return "[".concat(children.join(''), "](").concat(node.url, ")");

    case 'image':
      return "![".concat(node.url, "](").concat(node.url, ")");

    default:
      return children.join('');
  }
};

exports.serialize = serialize;

var prismTokenToSlateModel = function prismTokenToSlateModel(token) {
  switch (token.type) {
    case 'bold':
      {
        var result = {
          bold: true
        };

        if (token.content[1].content[0] instanceof _prismjs.default.Token) {
          result['italic'] = true;
          result['text'] = token.content[1].content[0].content[1].content[0];
        } else {
          result['text'] = token.content[1].content[0];
        }

        return result;
      }

    case 'italic':
      {
        var _result = {
          italic: true
        };

        if (token.content[1].content[0] instanceof _prismjs.default.Token) {
          _result['bold'] = true;
          _result['text'] = token.content[1].content[0].content[1].content[0];
        } else {
          _result['text'] = token.content[1].content[0];
        }

        return _result;
      }

    case 'url':
      {
        if (token.content[0].content === '!') {
          // Means this is an image
          return {
            type: 'image',
            url: token.content[4].content,
            children: [{
              text: ''
            }]
          };
        }

        return {
          type: 'link',
          url: token.content[3].content || '',
          children: [prismTokenToSlateModel(token.content[1].content[0])]
        };
      }

    case 'list':
      // Just add the content for now in case there's a nested list until we
      // add support for it. This will add a '*' to the text
      return {
        text: token.content
      };

    case 'title':
      // We don't support titles yet
      return {
        text: "".concat(token.content[0].content).concat(token.content[1])
      };

    default:
      if (_typeof(token) === 'object') {
        return {
          text: token.content || ''
        };
      }

      return {
        text: token
      };
  }
};

var groupListItems = function groupListItems(components) {
  var data = [];
  components.forEach(function (component) {
    if (!component.key) {
      data.push(component);
    } else {
      var previousComponent = data.length > 0 ? data[data.length - 1] : null;

      if (previousComponent && previousComponent.key === component.key) {
        data[data.length - 1] = _objectSpread(_objectSpread({}, previousComponent), {}, {
          children: [].concat(_toConsumableArray(previousComponent.children), _toConsumableArray(component.children))
        });
      } else {
        data.push(component);
      }
    }
  });
  return data;
};

var deserialize = function deserialize(string) {
  var key = ''; // Return a value array of children derived by splitting the string.

  var components = string.split('\n').map(function (line) {
    var tokens = _prismjs.default.tokenize(line, _prismjs.default.languages.markdown);

    if (tokens[0] instanceof _prismjs.default.Token && tokens[0].type === 'list') {
      var type = tokens[0].content === '*' ? 'bulleted-list' : 'numbered-list';

      if (!key || !key.includes(type === 'bulleted-list' ? '*>' : '1.>')) {
        key = "".concat(tokens[0].content, ">").concat(new Date().toISOString());
      }

      var nextContent = tokens[1];
      var restContent = tokens.splice(2);
      var children = [];

      if (nextContent) {
        children.push(prismTokenToSlateModel(nextContent.substr(1)));

        if (restContent.length > 0) {
          children = [].concat(_toConsumableArray(children), _toConsumableArray(restContent.map(function (token) {
            return prismTokenToSlateModel(token);
          })));
        }
      } else {
        children = [{
          text: ''
        }];
      }

      return {
        key: key,
        type: type,
        children: [{
          type: "list-item",
          children: children
        }]
      };
    } else {
      key = '';
      return {
        children: tokens.map(function (token) {
          return prismTokenToSlateModel(token);
        })
      };
    }
  });
  return groupListItems(components);
};

exports.deserialize = deserialize;